var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVnptLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 237 237",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1265B6;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1265B6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st0",
    d: "M209,98.3c0.9,5.2,1.3,10.9,1.3,16.3c0,48.4-41.2,87.7-92.6,88.9c0,0,28.3-11.8,59.1-49.8 C206.8,116.7,209,98.3,209,98.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st1",
    d: "M209.5,23.2c9.8,7.4,9.8,22.8-3.1,54.7c-16.3,40.2-54.7,79.4-74,97.9c-21.7,20.8-63.7,48.5-81,38.7 c-15.9-9-4.7-36.2-3.6-39c8.7-24.6,32-56.4,35.3-77.8c3.4-23.2-4.7-29.1-11.4-32.3c-4.1-2-24-7.8-40.3,23.2 c-16.3,31-1.6,64.7-1.6,64.7c-6-11.7-9.4-24.8-9.4-38.7c0-49.1,42.4-89,94.9-89c16.3,0,31.7,3.9,45.1,10.7 C160.5,36.3,195.5,12.7,209.5,23.2z M199.9,32.3c-8.9-9.1-33.5,7.2-33.5,7.2c11.3,6.7,20.8,15.6,28.2,26.1 C194.6,65.6,208.3,40.9,199.9,32.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVnptLogo);
export default __webpack_public_path__ + "static/media/VNPT_Logo.3812be036da7f9016351fd04232cec37.svg";
export { ForwardRef as ReactComponent };